import { fromEvent } from "rxjs";
import { onMessageFromWebApp, sendMessageToWebApp } from "./webAppMessenger";
import { INSTALL_AVAILABLE, INSTALL, INSTALL_SUCCESS, INSTALL_ERROR } from "./messageTypes";

let deferredPrompt;

console.log("Starting to listen for install events");
const beforeInstallPromptEvents = fromEvent(window, "beforeinstallprompt");
beforeInstallPromptEvents.subscribe(event => {
  console.log(INSTALL_AVAILABLE);
  // Prevent the mini-infobar from appearing on mobile
  event.preventDefault();
  // Stash the event so it can be triggered later.
  deferredPrompt = event;
  // Update UI notify the user they can install the PWA
  sendMessageToWebApp(INSTALL_AVAILABLE);
});

onMessageFromWebApp(INSTALL, async () => {
  console.log("Install Requested...");
  try {
    if (deferredPrompt) {
      const { outcome } = await deferredPrompt.prompt();
      if (outcome === "accepted") {
        sendMessageToWebApp(INSTALL_SUCCESS);
      } else {
        throw new Error("User Dismissed Install");
      }
    } else {
      throw new Error("No Install Prompt Available");
    }
  } catch (error) {
    console.error(error);
    sendMessageToWebApp(INSTALL_ERROR, { error });
  }
});
